/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_H1Inputs */

const en_terms_h1 = /** @type {(inputs: Terms_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Service`)
};

const ko_terms_h1 = /** @type {(inputs: Terms_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이용약관`)
};

const ja_terms_h1 = /** @type {(inputs: Terms_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用規約`)
};

/**
* | output |
* | --- |
* | "Terms of Service" |
*
* @param {Terms_H1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_h1 = /** @type {((inputs?: Terms_H1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_H1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_h1(inputs)
	if (locale === "ko") return ko_terms_h1(inputs)
	return ja_terms_h1(inputs)
});